import Box from "ds/components/Box";

import RunObservabilityStatTileCard from "./Tile";
import { RunObservabilityStatTile } from "./types";

type RunObservabilityStatTilesProps = {
  tiles: RunObservabilityStatTile[];
};

const RunObservabilityStatTiles = ({ tiles }: RunObservabilityStatTilesProps) => {
  if (tiles.length === 0) {
    return null;
  }

  return (
    <Box direction="row" gap="large" fullWidth>
      {tiles.map((tile) => (
        <RunObservabilityStatTileCard key={tile.id} {...tile} />
      ))}
    </Box>
  );
};

export default RunObservabilityStatTiles;
